module.exports = __webpack_public_path__ + "static/img/1935_phase_function_Paper_PointsHejduk_Prediction.9d27479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1935_phase_function_Paper_PointsHejduk_Prediction.png
// module id = OqSr
// module chunks = 0